/**
 * @module app.fm
 */

import { DynamicViews } from 'app/shared/config/modules';
import { PLATFORM } from 'aurelia-pal';

export function getFaxManagementQueueNavigationTypes(): DynamicViews {
    return {
        'FM.Document': [
            {
                title: 'fm:queueTypes.document.$title',
                url: PLATFORM.moduleName('app/fm/components/queues/document-queue-navigation')
            }
        ]
    };
}
